const getIconColor = (colors, iconType, disabled = false) => {
    if (disabled)
        return colors.neutrals.borderAlpha;
    switch (iconType) {
        case 'brand':
            return colors.brand.primary.alpha;
        case 'inverted':
            return colors.neutrals.background;
        default:
            // utility
            return colors.neutrals.textAlpha;
    }
};
export default getIconColor;
//# sourceMappingURL=getIconColor.js.map